
<div class="padding-20 ui-g" id="c3_clusterHeadNewList_Modal">
  <br />
  <div class="ui-g-12 ui-g">
    <div class="ui-g-1"><b>{{ 'campaign.listName' | translate }}</b><span class="asterix">*</span></div>
    <div class="ui-g-11">
        <app-form-fields #list_name data-testid="list_name" [(fieldModel)]="fieldModel.name" [name]="'list_name'" [required]="true" [label]="''" [type]="'string'"></app-form-fields>
      </div>
  </div>
  <br />


  <!-- Bottoni Annulla e Aggiungi -->

  <div class="ui-dialog-footer fixed-buttons buttonsContainer">
    <button pButton (click)="onClickAnnulla_ModalClusterHead()" type="button" class="k-generic-btn footer-btn" label="{{'common.cancel' | translate}}"></button>
    <button pButton type="button" (click)="onClickAggiungi_ModalClusterHead()" type="button" class="k-generic-btn footer-btn" label="{{'common.add' | translate}}"></button>
    <div class="clear_fix"></div>
  </div>

  <br />
  <br />
  <br />

  <app-campaign-3-kontable
  *ngIf="clusterHeadList && show.table"
  id="clusterHeadListTable"
  [columns] = "[
  { field: 'code', title: 'campaign.clusterCode' },
  { field: 'clusterDescription', title: 'campaign.clusterDescription' },
  { field: 'date_start', title: 'campaign.startDate', type: 'date', filterType: dateFilter },
  { field: 'date_end', title: 'campaign.endDate', type: 'date', filterType: dateFilter }
]"

  [paginationType]="paginationType"
  [showInfoButton]="false"
  [showGlobalFilter]="false"
  [showDetailsButton]="false"
  [showRecoverButton]="false"
  [showAddButton]="false"
  [showDeleteButton]="false"
  [showEditButton]="false"
  [showDeleteButton]="false"
  [allowSelectRow]="false"
  [source]="clusterHeadList"
  [showSelectButton]="true"
  (onSelected)="onClusterHeadSelected($event)"
  #clusterHeadListTable>


</app-campaign-3-kontable>


</div>



// WEBPACK FOOTER //
// ./src/app/views/campaign-3/components/modals/create-cluster-head-list/campaign-3-create-cluster-head-list.component.html